export enum SourceType{
    Internal = 'Internal',
    Direct = 'Direct',
    Consultancy = 'Consultancy'
}